<app-oncall-home></app-oncall-home>
@if (pageEnabled) {
  <div style="display: flex; flex-direction: column; align-items: center;">
    <p class="alerts-header">Alerts</p>
    <div style="padding-bottom: 0;">
      <mat-form-field style="padding: 5px;">
        <mat-label for="teamFilter">Team:</mat-label>
        <mat-select id="teamFilter" [(ngModel)]="selectedTeam">
          <mat-option value="All">All</mat-option>
          @for (team of teams; track team) {
            <mat-option [value]="team.name">{{ team.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field style="padding: 5px;">
        <mat-label for="statusFilter">Status:</mat-label>
        <mat-select id="statusFilter" [(ngModel)]="selectedStatus">
          <mat-option value="All">All</mat-option>
          <mat-option value="Triggered">Triggered</mat-option>
          <mat-option value="Acknowledged">Acknowledged</mat-option>
          <mat-option value="Resolved">Resolved</mat-option>
          <mat-option value="Suppressed">Suppressed</mat-option>
          <mat-option value="Forwarded">Forwarded</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button style="margin-top: -10px;" class="button" (click)="refreshAlerts()">Refresh</button>
    </div>
    <div style="padding-top: 0;">
      <table matSort class="mat-elevation-z8" #alertsTable mat-table [dataSource]="dataSource" multiTemplateDataRows
        aria-describedby="alerts">
        @for (column of columns; track column) {
          <ng-container [matColumnDef]="column.columnDef">
            <th mat-header-cell class="header-row" *matHeaderCellDef mat-sort-header>
              {{ column.header }}
            </th>
            <td mat-cell *matCellDef="let alert"
              [style.color]="column.columnDef === 'status' ? getStatusColor(alert.state.status) : ''">
              <ng-container>
                {{ column.cell(alert) }}
              </ng-container>
            </td>
          </ng-container>
        }
        <ng-container matColumnDef="actions">
          <th mat-header-cell class="header-row" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let alert">
            <button mat-raised-button (click)="performAlertAction(alert, 'acknowledge', $event)"
              [disabled]="isAlertAcknowledgedOrResolved(alert) || disableAckEscResButtons()"
            [ngClass]="{ 'button': !isAlertAcknowledgedOrResolved(alert) }">Ack</button>
            <button mat-raised-button (click)="performAlertAction(alert, 'escalate', $event)"
              [disabled]="isAlertAcknowledgedOrResolved(alert) || disableAckEscResButtons()"
            [ngClass]="{ 'button escalate-button': !isAlertAcknowledgedOrResolved(alert) }">Escalate</button>
            <button mat-raised-button (click)="performAlertAction(alert, 'resolve', $event)"
              [disabled]="isAlertResolved(alert) || disableAckEscResButtons()"
            [ngClass]="{ 'button resolve-button': !isAlertResolved(alert) }">Resolve</button>
          </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let alert" [attr.colspan]="columns.length + 1">
            <div class="alert-detail-container" [@detailExpand]="alert === expandedRow ? 'expanded' : 'collapsed'">
              <div class="alert-detail">
                <div class="title-container"><span class="detail-title">Details</span>
                <div class="detail-text">
                  {{ alert.alertDetails.data.essentials.description }}
                </div>
              </div><br />
              <div class="title-container"><span class="detail-title">Escalation Level</span>
              <div class="detail-text">
                {{ alert.state.escalationLevel }}<br />
              </div>
            </div>
          </div>
          <div class="alert-detail">
            <div class="title-container"><span class="detail-title">History</span>
            <div class="detail-text">
              @for (history of alert.state.history; track history) {
                - {{ history }}<br />
              }
            </div>
          </div><br />
          <div class="title-container"><span class="detail-title">Alert Id</span>
          <div class="detail-text">
            {{ alert.alertDetails.id }}
          </div>
          <button mat-raised-button class="button" style="margin-left: 2rem;"
            (cdkCopyToClipboardCopied)="onCopy($event)"
          [cdkCopyToClipboard]="alert.alertDetails.id">Copy</button>
        </div>
      </div>
    </div>
  </td>
</ng-container>
<tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
<tr #tableRow mat-row *matRowDef="let alert; columns: displayedColumns;" style="height: 40px;"
  class="release-row clickable" [class.expanded-alert]="expandedRow === alert" (click)="toggleRow(alert)">
</tr>
<tr mat-row *matRowDef="let alert; columns: ['expandedDetail']" class="alert-detail-row"></tr>
</table>
</div>
<mat-paginator [pageSizeOptions]="[10, 20, 30]" [pageSize]="pageSize" aria-label="Select page">
</mat-paginator>
</div>
} @else {
  <div>
    <h2>This page has been temporarily disabled by the Platform Team.</h2>
  </div>
}
